import * as React from 'react'
import { connect } from 'react-redux'
import Container from '../components/layout/Container'
import Page from '../components/layout/Page'
import { ApplicationState } from '../store'
import { Loading } from '../components/data/Loading'
import { Employees } from '../components/employees'
import { ErrorPage } from '../components/data/ErrorPage'
import { RouteType } from '../types/routes'
import { useLoadSalonData } from '../hooks/useLoadSalonData'
import { SalonDetails } from '../components/SalonDetails/SalonDetails'
import { Separator } from '../styles/components/separator'
import styled from '../utils/styled'

interface PropsFromState {
  loading: boolean
  errors?: string
}

type AllProps = PropsFromState

const EmployeesPage: React.FC<AllProps> = ({ loading, errors }) => {
  useLoadSalonData({ redirectTo: RouteType.Home })

  if (errors) return <ErrorPage errors={errors} />

  return (
    <Page>
      <Container>
        {loading ? (
          <Loading />
        ) : (
          <>
            <SalonDetailsContainer>
              <SalonDetails />
            </SalonDetailsContainer>
            <Separator />
            <Employees />
          </>
        )}
      </Container>
    </Page>
  )
}

const SalonDetailsContainer = styled('div')`
  display: block;

  @media (min-width: ${props => props.theme.breakpoints.sm}) {
    display: none;
  }
`

const mapStateToProps = ({ employees }: ApplicationState) => ({
  loading: employees.loading,
  errors: employees.errors
})

export default connect(mapStateToProps)(EmployeesPage)
